export type AtLeastOne<T, Keys extends keyof T = keyof T> =
  Partial<T> & {
    [K in Keys]-?: Required<Pick<T, K>>
  }[Keys]

export enum Devices {
  WINDOWS = 'windows',
  ANDROID = 'android',
  IOS = 'ios',
  MAC = 'mac',
  UNKNOWN = 'unknown'
}
export type DeviceType = `${Devices}`
export type ProductType = 'subscription' | 'trial'
export type PurchaseSource = 'baggins' | 'stripe' | 'trial' | 'ration' | 'codes' | 'play' | 'huawei' | 'tpintegration' | 'ludium'

export const SubscriptionStatus = {
  Pending: 0,
  Purchased: 1,
  RenewalStopped: 2,
  RenewalPending: 3,
  RenewalPaused: 4,
  OnHold: 5,
  Expired: 6,
  DueChange: 7,
} as const;

export type SubscriptionStatus =
  (typeof SubscriptionStatus)[keyof typeof SubscriptionStatus];

export const PEGI_AGE = {
    'PEGI_18': '18',
    'PEGI_16': '16',
    'PEGI_12': '12',
    'PEGI_7': '7',
    'PEGI_3': '3',
    'All': 'All'
}
export type PEGI_AGE =
  (typeof PEGI_AGE)[keyof typeof PEGI_AGE];

export type PEGISize = {
  medium: 'medium',
  small: 'small'
}

export type ImageType = {
  esc_075_url: string
  esc_100_url: string
  esc_133_url: string
  esc_150_url: string
  esc_200_url: string
  esc_300_url: string
  esc_400_url: string
}

export type ImageKey = keyof ImageType